module.exports = __webpack_public_path__ + "media/img/covers/team-cover-a7e497866068203bf01f96dbbda4d334.jpg";